import React, { createContext, useState, useEffect, useContext } from 'react';
import { getDatabase, ref, onValue, set, get } from 'firebase/database';

const BookingContext = createContext();

export function BookingProvider({ children }) {
  const [isBookingActive, setIsBookingActive] = useState(true);

  useEffect(() => {
    const db = getDatabase();
    const bookingStatusRef = ref(db, 'bookingStatus');
    
    const unsubscribe = onValue(bookingStatusRef, (snapshot) => {
      const data = snapshot.val();
      if (data !== null) {
        setIsBookingActive(data.isActive);
      } else {
        // Initialize booking status if it doesn't exist
        set(bookingStatusRef, { isActive: true, updatedAt: new Date().toISOString() });
      }
    });

    return () => unsubscribe();
  }, []);

  const toggleBookingStatus = async (status) => {
    try {
      console.log('Attempting to update booking status to:', status);
      const db = getDatabase();
      const bookingRef = ref(db, 'bookingStatus');
      
      // First try to read the current value
      try {
        const snapshot = await get(bookingRef);
        console.log('Current booking status from DB:', snapshot.val());
      } catch (readError) {
        console.error('Error reading booking status:', readError);
      }
      
      // Then try to write the new value
      try {
        await set(bookingRef, {
          isActive: status,
          updatedAt: new Date().toISOString()
        });
        console.log('Successfully updated booking status');
        setIsBookingActive(status);
        return true;
      } catch (writeError) {
        console.error('Error writing booking status:', writeError);
        throw writeError; // Re-throw to be caught by the outer catch
      }
    } catch (error) {
      console.error('Error in toggleBookingStatus:', {
        message: error.message,
        code: error.code,
        name: error.name,
        stack: error.stack
      });
      return false;
    }
  };

  return (
    <BookingContext.Provider value={{ isBookingActive, toggleBookingStatus }}>
      {children}
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
}
